export const setCssVariable = (variableName, variableValue) => {
  const root = document.querySelector(":root");

  root.style.setProperty(variableName, variableValue);
};
